/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseResponseEntity } from '../models/BaseResponseEntity';
import type { HealthCheckBIDVDto } from '../models/HealthCheckBIDVDto';
import type { InquiryTransHistoryDto } from '../models/InquiryTransHistoryDto';
import type { SyncDomesticBankH2hEntity } from '../models/SyncDomesticBankH2hEntity';
import type { SyncDomesticBanksDto } from '../models/SyncDomesticBanksDto';
import type { SyncTransHistoryDto } from '../models/SyncTransHistoryDto';
import type { SyncTransHistoryH2hEntity } from '../models/SyncTransHistoryH2hEntity';
import type { TransHistoryH2hEntity } from '../models/TransHistoryH2hEntity';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class BidvH2HService {
  /**
   * Vấn tin danh sách mã ngân hàng
   * Đồng bộ danh sách ngân hàng từ BIDV.
   * @param requestBody
   * @returns SyncDomesticBankH2hEntity
   * @throws ApiError
   */
  public static bidvH2HControllerSyncDomesticBank(
    requestBody: SyncDomesticBanksDto,
  ): CancelablePromise<SyncDomesticBankH2hEntity> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/bidv/h2h/domestic-bank/sync',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Đồng bộ giao dịch từ lịch sử tài khoản thanh toán vào hệ thống
   * Đồng bộ các giao dịch hợp lệ từ BIDV vào hệ thống.
   * @param requestBody
   * @returns SyncTransHistoryH2hEntity
   * @throws ApiError
   */
  public static bidvH2HControllerSyncTransHistory(
    requestBody: SyncTransHistoryDto,
  ): CancelablePromise<SyncTransHistoryH2hEntity> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/bidv/h2h/trans-history/sync',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Vấn tin lịch sử giao dịch tài khoản BIDV
   * @param requestBody
   * @returns TransHistoryH2hEntity
   * @throws ApiError
   */
  public static bidvH2HControllerInquiryTransHistory(
    requestBody: InquiryTransHistoryDto,
  ): CancelablePromise<TransHistoryH2hEntity> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/bidv/h2h/trans-history/inquiry',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Kiểm tra trạng thái tài khoản BIDV
   * Kiểm tra kết nối và trạng thái tài khoản BIDV.
   * @param requestBody
   * @returns BaseResponseEntity
   * @throws ApiError
   */
  public static bidvH2HControllerHealthCheck(
    requestBody: HealthCheckBIDVDto,
  ): CancelablePromise<BaseResponseEntity> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/bidv/h2h/health-check',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
}
